import { z } from 'zod';
import { YearMonthSchema } from './common.js';
export const CompositionBandSchema = z.object({
    key: z.string(),
    label: z.string(),
    kind: z.enum(['track', 'otherCatalogue', 'otherNew', 'otherUnknown']),
    rank: z.number().int().optional(),
    values: z.array(z.number()),
});
export const CompositionSchema = z.object({
    months: z.array(YearMonthSchema),
    bands: z.array(CompositionBandSchema),
    totals: z.array(z.number()),
    /** True when the anchor is not the last day of its month (that month is shown but partial). */
    partialLastMonth: z.boolean(),
});
//# sourceMappingURL=composition.js.map